import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LearningService = /** @class */ (function () {
    function LearningService(http) {
        this.http = http;
    }
    LearningService.prototype.getLearningListBySearch = function (isActive, search) {
        var Url = cmsApi + '/get_LearningListBySearch';
        var Body = { isActive: isActive, search: search };
        // console.log(Url, Body);
        return;
    };
    LearningService.prototype.getLearningByID = function (learningid) {
        var URL = cmsApi + '/get_LearningById';
        var body = { learningid: learningid };
        return this.http.post(URL, body);
    };
    LearningService.prototype.getLearning = function () {
        var URL = cmsApi + '/get_LearningList_front';
        return this.http.post(URL, "");
    };
    LearningService.ngInjectableDef = i0.defineInjectable({ factory: function LearningService_Factory() { return new LearningService(i0.inject(i1.HttpClient)); }, token: LearningService, providedIn: "root" });
    return LearningService;
}());
export { LearningService };
